module.exports = __webpack_public_path__ + "img/glassdoor.497bb580.png";